import { LazyLoad } from 'app/utils';

export const NotificationListPage = LazyLoad(
  () => import('./index'),
  (module) => module.NotificationListPage,
);
